var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg100MicGrayOpacity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333496,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#828282",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66683 11.6579H8.80016C8.80016 12.1642 8.90683 12.6363 9.08683 13.0605L8.26683 13.9021C7.8935 13.2316 7.66683 12.4721 7.66683 11.6579ZM10.3468 11.7742C10.3468 11.7332 10.3335 11.6989 10.3335 11.6579V7.55263C10.3335 6.41684 11.2268 5.5 12.3335 5.5C13.4402 5.5 14.3335 6.41684 14.3335 7.55263V7.67579L10.3468 11.7742ZM17.4868 6.18421L18.3335 7.05316L14.3268 11.1653V11.6579C14.3268 12.7937 13.4402 13.7105 12.3335 13.7105C12.1868 13.7105 12.0402 13.69 11.9002 13.6558L10.7935 14.7916C11.2668 15.0174 11.7935 15.1474 12.3335 15.1474C14.1735 15.1474 15.8668 13.7105 15.8668 11.6579H17.0002C17.0002 13.9911 15.1868 15.9205 13.0002 16.2558V18.5H11.6668V16.2558C11.0602 16.1668 10.4868 15.9479 9.9735 15.64L7.18016 18.5L6.3335 17.6311L17.4868 6.18421Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100MicGrayOpacity);
export default __webpack_public_path__ + "static/media/100-mic-gray-opacity.50f266c15c1fbdebb722dc0afbe91b15.svg";
export { ForwardRef as ReactComponent };